export const API_ENDPOINT = {
  LOGIN_TYPE: "login-type",
  LOGIN: "login",
  LOGOUT: "logout",
  VERIFY_OTP: "verify-otp",
  RESEND_OTP: "resend-otp",
  HOME: "home",
  CHANGE_ADDRESS: "change-address",
  REWARD_DETAIL: "reward-detail",
  PROFILE_DETAILS: "profile-details",
  UPDATE_PROFILE_DETAILS: "update-profile-details",
  REWARDS_FILTER: "rewards-filter",
  REWARDS: "rewards",
  CART: "carts",
  ALL_MODULE_COUNT: "get-all-modules-counts",
  APPLY_CODE: "apply-code",
  REMOVE_CODE: "remove-code",
  ORDER_SUMMARY: "order-summary",
  REFERRAL_CODE: "referal-code",
  PLACE_ORDER: "place-order",
  ORDER_HISTORY: "order-history",
  ORDER_DETAILS: "order-details",
  POINT_HISTORY: "point-history",
  CHECKOUT: "checkout",
  GET_APPLICABLE_COUPONS: "get-applicable-coupons",
  NOTIFICATION: "read-push-notifications",
};
